<template>
  <div>
    <div style="margin-bottom: 5px">
      <el-input
          v-model="name"
          placeholder="请输入名字"
          suffix-icon="el-icon-a-042"
          style="width: 200px"
          @keyup.enter.native="loadPost"
      ></el-input>
      <el-select
          v-model="sex"
          filterable
          placeholder="请选择性别"
          style="margin-left: 5px"
      >
        <el-option
            v-for="item in sexs"
            :key="item.value"
            :value="item.value"
            :label="item.label"
        >
        </el-option>
      </el-select>

      <!-- 部门筛选 -->
      <el-select
          v-model="deptId"
          filterable
          placeholder="请选择部门"
          style="margin-left: 5px"
      >
        <el-option
            v-for="item in deptList"
            :key="item.id"
            :value="item.id"
            :label="item.deptName"
        >
        </el-option>
      </el-select>
      <el-button
          type="primary"
          style="margin-left: 5px; font-size: 18px"
          @click="loadPost"
      >
        查询
      </el-button>
      <el-button
          type="warning"
          @click="resetParam"
          style="font-size: 18px"
      >
        重置
      </el-button>

      <el-button
          type="primary"
          style="margin-left: 5px; font-size: 18px"
          @click="add"
      >
        新增
      </el-button>
    </div>
    <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
        border
        style="width: 100%"
        :stripe="true"
        :show-overflow-tooltip="true"
    >
      <el-table-column type="index" label="ID" width="60" align="center"> </el-table-column>
      <el-table-column prop="name" label="姓名"  align="center">
      </el-table-column>
      <el-table-column prop="sex" label="性别" align="center" >
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.sex === 1 ? 'primary' : 'success'"
              disable-transitions
          >{{ scope.row.sex === 1 ? "男" : "女" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="部门" align="center" >
      </el-table-column>
      <el-table-column prop="roleId" label="角色" align="center" >
        <template slot-scope="scope">
          <el-tag
              :type="
                            scope.row.roleId === 0
                                ? 'danger'
                                : scope.row.roleId === 1
                                ? 'primary'
                                : 'success'
                        "
              disable-transitions
          >{{
              scope.row.roleId === 0
                  ? "超级管理员"
                  : scope.row.roleId === 1
                      ? "管理员"
                      : "用户"
            }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="operate"
          label="操作"
          align="center"
          fixed="right"
      >
        <template slot-scope="scope">
          <el-button
              style="font-size: 18px"
              type="success"
              @click="mod(scope.row)"
          >
            编辑
          </el-button>
          <el-popconfirm
              title="确定删除吗？"
              @confirm="del(scope.row.id)"
              style="margin-left: 5px"
          >
            <el-button
                slot="reference"
                style="font-size: 18px"
                v-if="user.roleId != 1"
                type="danger"
            >
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>

    <el-dialog
        title="用户信息"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <!-- 账号 隐藏 -->
        <!-- 密码 隐藏 -->
        <el-form-item label="名字" prop="name">
          <el-col :span="20">
            <el-input v-model="form.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="部门" prop="deptId">
          <el-col :span="20">
            <el-select v-model="form.deptId" placeholder="请选择部门">
              <el-option
                  v-for="item in deptList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.deptName"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 电话 隐藏 -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="centerDialogVisible = false"
            style="font-size: 18px"
        >
          取 消
        </el-button>
        <el-button type="primary" @click="save" style="font-size: 18px">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "UserManage",
  data() {
    let checkDuplicate = (rule, value, callback) => {
      if (this.form.id) {
        return callback();
      }
      this.$axios
          .get(this.$httpUrl + "/user/findByNo?no=" + this.form.no)
          .then((res) => res.data)
          .then((res) => {
            if (res.code != 200) {
              callback();
            } else {
              callback(new Error("账号已经存在"));
            }
          });
    };

    return {
      user: JSON.parse(sessionStorage.getItem("CurUser")),
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      name: "",
      sex: "",
      deptId: "",
      sexs: [
        { value: "1", label: "男" },
        { value: "0", label: "女" },
      ],
      deptList: [],
      centerDialogVisible: false,
      form: {
        id: "",
        no: "",
        name: "",
        password: "123456",
        sex: "0",
        phone: "",
        roleId: "2",
        deptId: "",
      },
      rules: {
        no: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" },
          { validator: checkDuplicate, trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入名字", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, max: 8, message: "长度在 3 到 8 个字符", trigger: "blur" },
        ],
        deptId: [
          { required: true, message: "请选择部门", trigger: "change" },
        ]
        // 电话规则全部删除
      },
    };
  },
  methods: {
    resetForm() {
      this.$refs.form.resetFields();
    },
    loadDeptList() {
      this.$axios.get(this.$httpUrl + "/dept/list")
          .then(res => res.data)
          .then(res => {
            if (res.code === 200) {
              this.deptList = res.data;
            }
          })
    },
    del(id) {
      this.$axios
          .get(this.$httpUrl + "/user/del?id=" + id)
          .then((res) => res.data)
          .then((res) => {
            if (res.code == 200) {
              this.$message({message: "操作成功！", type: "success"});
              this.loadPost();
            } else {
              this.$message({message: "操作失败！", type: "error"});
            }
          });
    },
    mod(row) {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.form.id = row.id;
        // 编辑时：账号/密码/电话 赋值但页面不显示，不修改
        this.form.no = row.no;
        this.form.password = "";
        this.form.name = row.name;
        this.form.sex = row.sex + "";
        this.form.phone = row.phone;
        this.form.roleId = row.roleId;
        this.form.deptId = row.deptId;
      });
    },
    add() {
      this.centerDialogVisible = true;
      this.form.id = undefined;
      // 新增默认密码 123456
      this.form.password = "123456";
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    doSave() {
      this.$axios
          .post(this.$httpUrl + "/user/save", this.form)
          .then((res) => res.data)
          .then((res) => {
            if (res.code == 200) {
              this.$message({message: "操作成功！", type: "success"});
              this.centerDialogVisible = false;
              this.loadPost();
              this.resetForm();
            } else {
              this.$message({message: "操作失败！", type: "error"});
            }
          });
    },
    doMod() {
      this.$axios
          .post(this.$httpUrl + "/user/update", this.form)
          .then((res) => res.data)
          .then((res) => {
            if (res.code == 200) {
              this.$message({message: "操作成功！", type: "success"});
              this.centerDialogVisible = false;
              this.loadPost();
              this.resetForm();
            } else {
              this.$message({message: "操作失败！", type: "error"});
            }
          });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.id ? this.doMod() : this.doSave();
        } else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.loadPost();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadPost();
    },
    resetParam() {
      this.name = "";
      this.sex = "";
      this.deptId = "";
    },
    loadPost() {
      this.$axios
          .post(this.$httpUrl + "/user/listPageC1", {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            param: {
              name: this.name,
              sex: this.sex,
              roleId: "2",
              deptId: this.deptId,
            },
          })
          .then((res) => res.data)
          .then((res) => {
            if (res.code == 200) {
              this.tableData = res.data;
              this.total = res.total;
            } else {
              alert("获取数据失败");
            }
          });
    },
  },
  mounted() {
    this.loadDeptList();
    this.loadPost();
  },
};
</script>

<style scoped>
</style>